import { useMemo } from 'react';
import { useGeoMarkupStore } from '../store';
import { useDeviceLayout } from './useDeviceLayout';

/**
 * Returns the width of any currently open SlidePanel (reactive during resize).
 *
 * Uses the generic `openSlidePanelCount` counter from SlidePanel self-registration,
 * so every SlidePanel automatically affects toolbar repositioning without
 * hardcoding individual panel flags.
 *
 * Returns 0 if no panel is open or on mobile (fullscreen).
 *
 * @returns {number} Current panel width in pixels, or 0 if closed/mobile
 */
export const useSlidePanelWidth = (): number => {
  const panelWidth = useGeoMarkupStore((s) => s.ui.panelWidth);
  const openSlidePanelCount = useGeoMarkupStore(
    (s) => s.ui.openSlidePanelCount
  );
  const { isMobile } = useDeviceLayout();

  return useMemo(() => {
    if (isMobile) return 0;
    if (openSlidePanelCount > 0) return panelWidth;
    return 0;
  }, [panelWidth, openSlidePanelCount, isMobile]);
};
